import { render, staticRenderFns } from "./RiskAssessPDF.vue?vue&type=template&id=5ff8dbe8"
import script from "./RiskAssessPDF.vue?vue&type=script&lang=js"
export * from "./RiskAssessPDF.vue?vue&type=script&lang=js"
import style0 from "./RiskAssessPDF.vue?vue&type=style&index=0&id=5ff8dbe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports